import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { saveBookingStepUrl } from "../store/bookingStepUrlsActionCreators";
import { BookingStepKey } from "../constants/bookingSteps";

/** Persists the current URL (pathname + search) as the saved location of the given booking step. */
export const useSaveBookingStepUrl = (step: BookingStepKey) => {
	const dispatch = useDispatch();
	const { pathname, search } = useLocation();

	useEffect(() => {
		dispatch(saveBookingStepUrl(step, `${pathname}${search}`));
	}, [dispatch, step, pathname, search]);
};
